module.exports = __webpack_public_path__ + "img/twitter_a.aacf44f2.svg";